import { jsx as _jsx } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { useConfig } from "@/contexts/cdpConfig";
import { useContactContext, useContactSections } from "@/contexts/contact";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { useCustomerAction } from "@/hooks";
import { EnvelopeIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
export const MailButton = ({ rootTestId, av_zone, legacyTrackingInfos, }) => {
    const { t } = useI18n();
    const isPreviewMode = useConfig().previewMode;
    const isProject = useIsNewBuildProject();
    const { customerActionExposeInteraction } = useCustomerAction();
    const { toggleModal } = useContactContext();
    const { emailButtonAgency, emailButtonPrivate } = brandConfiguration.lokaliseSpecificKeys;
    const isPrivateOwner = useContactSections().contactCard.isPrivateOwner;
    const mailBtnText = isProject
        ? t("contact.form.project.email")
        : t(isPrivateOwner ? emailButtonPrivate : emailButtonAgency);
    const trackCustomerActionLeadMailInterestView = async () => await customerActionExposeInteraction([
        { key: "interaction", value: "openContactForm" },
    ]);
    const handlePress = () => {
        if (isPreviewMode)
            return;
        trackCustomerActionLeadMailInterestView();
        toggleModal({
            av_zone,
            legacyTrackingInfos, //tracking GA3 for harvest
        });
    };
    return (_jsx(Button, { testId: `${rootTestId}.email`, variant: "primary", icon: EnvelopeIcon, iconPosition: "start", isFullWidth: true, onPress: handlePress, isDisabled: isPreviewMode, children: mailBtnText }));
};
